module.exports = __webpack_public_path__ + "static/media/LocalAxis.32acf9a8.svg";